import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import InterpreterModeOutlinedIcon from '@mui/icons-material/InterpreterModeOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import routes from '../../../Utils/routes';
import { useStyles } from '../styles';
import { ListItemButton, ListItemIcon, ListItemText, useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';
import MentorIcon from '../../../Assets/mentorIcon.svg';

interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
}

const SideNavTabs: React.FunctionComponent<SideNavProps> = ({ handleListClick }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const getFirstPath = pathname.split('/').filter((items: string) => {
    return items && items !== '';
  });

  const is1980 = useMediaQuery('(max-width:1280px)');

  const sideNavContents = [
    {
      icon: (isActive: boolean) => {
        return <HomeOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Home',
      link: routes.home,
      name: 'home',
    },
    {
      icon: (isActive: boolean) => {
        return <AccountCircleIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'My Profile',
      link: routes.myProfile,
      name: 'my%20Profile',
    },
    {
      icon: (isActive: boolean) => {
        return <AutoAwesomeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Events',
      link: routes.events,
      name: 'events',
    },
    {
      icon: (isActive: boolean) => {
        return <WorkOutlineOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Jobs',
      link: routes.jobs,
      name: 'jobs',
    },
    {
      icon: (isActive: boolean) => {
        return <InterpreterModeOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Mentorship',
      link: routes.mentorship,
      name: 'mentorship',
    },
    {
      icon: (isActive: boolean) => {
        return <PaymentsOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Fundraise',
      link: routes.fundraise,
      name: 'fundraise',
    },
    {
      icon: (isActive: boolean) => {
        return <PeopleOutlineOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Network',
      link: routes.network,
      name: 'network',
    },
    {
      icon: (isActive: boolean) => {
        return <GroupsOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Groups',
      link: routes.groups,
      name: 'groups',
    },
    {
      icon: (isActive: boolean) => {
        return <DocumentScannerOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Survey',
      link: routes.survey,
      name: 'survey',
    },
    {
      icon: (isActive: boolean) => {
        return <ContactSupportOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Service & Support',
      link: routes.service,
      name: 'service',
    },
    {
      icon: (isActive: boolean) => {
        return <LogoutIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Logout',
      link: routes.login,
      name: 'logout',
    },
  ];

  return (
    <>
      {is1980 ? (
        <div style={{ overflow: 'auto', height: is1980 ? `calc(100vh - 220px)` : `calc(100vh - 270px)` }} className="scrollbar-cusgray">
          {sideNavContents?.map((items, index) => {
            return (
              <ListItemButton
                onClick={() => {
                  handleListClick(items.link, index);
                }}
                style={{
                  marginTop: '1px',
                }}
                className={`${classes.listItemButton} ${getFirstPath[0] === items.name && classes.listItemButtonActive}`}
              >
                <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>{items.icon(getFirstPath[0] === items.name)}</ListItemIcon>
                <ListItemText
                  className={`${classes.listItemText} ${getFirstPath[0] === items.name && classes.listItemTextActive}`}
                  sx={{
                    display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                  }}
                >
                  {items.label}
                </ListItemText>
              </ListItemButton>
            );
          })}
        </div>
      ) : (
        <>
          <div style={{ overflow: 'auto', height: is1980 ? `calc(100vh - 250px)` : `calc(100vh - 270px)` }} className="scrollbar-cusgray">
            {sideNavContents?.slice(0, -1)?.map((items, index) => {
              return (
                <ListItemButton
                  onClick={() => {
                    handleListClick(items.link, index);
                  }}
                  style={{
                    marginTop: '1px',
                  }}
                  className={`${classes.listItemButton} ${getFirstPath[0] === items.name && classes.listItemButtonActive}`}
                >
                  <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>{items.icon(getFirstPath[0] === items.name)}</ListItemIcon>
                  <ListItemText
                    className={`${classes.listItemText} ${getFirstPath[0] === items.name && classes.listItemTextActive}`}
                    sx={{
                      display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                    }}
                  >
                    {items.label}
                  </ListItemText>
                </ListItemButton>
              );
            })}
          </div>
          <div>
            {sideNavContents.slice(-1)?.map((items, index) => {
              return (
                <ListItemButton
                  onClick={() => {
                    handleListClick(items.link, index);
                  }}
                  style={{
                    marginTop: '0px',
                    position: 'absolute',
                    bottom: '0px',
                    marginBottom: '10px',
                  }}
                  className={`${classes.listItemButton} ${getFirstPath[0] === items.name && classes.listItemButtonActive}`}
                >
                  <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>{items.icon(getFirstPath[0] === items.name)}</ListItemIcon>
                  <ListItemText
                    className={`${classes.listItemText} ${getFirstPath[0] === items.name && classes.listItemTextActive}`}
                    sx={{
                      display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                    }}
                  >
                    {items.label}
                  </ListItemText>
                </ListItemButton>
              );
            })}
          </div>
        </>
      )}
    </>
  );
};

export default SideNavTabs;
